import React, { useState, ChangeEvent } from "react"
import InputAdornment from "@mui/material/InputAdornment"
import BankItem from "../../components/BankItem"
import { useGetBanksList } from "../../api/hooks/useGetBanksList"
import {
  BanksContainer,
  ContentContainer,
  Description,
  SearchInput,
  Loading,
  BankCard,
  IconContainer,
} from "./styled"
import UIIcon from "../../components/UIIcon"
import { BankSelectionProps } from "./props"
import ContactItem from "../../components/ContactItem"
import { PHKOString } from "../../components/PHKOString"
import { RNKO_BANK_ID } from "../../utils/constants"

const BankSelection = ({
  handleBankClick,
  defaultBank,
  bankSelectDescription,
  isLoading,
  showFooter,
  blockedBanksIds = [],
  role,
  scenario,
  disableViewFullList = false,
  disableToken = false,
}: BankSelectionProps) => {
  const [banksFilter, setBanksFilter] = useState("")
  const bankReqParams = role || scenario ? { role, scenario } : null
  const { data } = useGetBanksList(bankReqParams, disableToken)

  const handleBanksInputChange = (
    evt: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { value } = evt.target
    setBanksFilter(value)
  }

  const hiddenBanks = [...blockedBanksIds, RNKO_BANK_ID]

  const filteredBanksBySearch = data?.items.filter((bank) =>
    bank.title.toLowerCase().includes(banksFilter.toLowerCase()),
  )
  const filteredBanks = filteredBanksBySearch?.filter((bank) =>
    blockedBanksIds ? !hiddenBanks.includes(bank.bankId) : bank,
  )

  const shouldShowBanks = !disableViewFullList || banksFilter.length > 0

  return (
    <ContentContainer>
      {bankSelectDescription && (
        <Description variant="h5">{bankSelectDescription}</Description>
      )}
      <SearchInput
        placeholder="Поиск банка"
        value={banksFilter}
        onChange={handleBanksInputChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <UIIcon iconName="search" size={24} />
            </InputAdornment>
          ),
        }}
      />
      {defaultBank && (
        <BankCard onClick={() => handleBankClick(defaultBank)}>
          <ContactItem
            name={defaultBank.title}
            bank={defaultBank}
            iconType="bank"
            desciption={
              defaultBank.bankId
                ? "Банк выбран получателем по умолчанию"
                : "Выберите Банк"
            }
          />
        </BankCard>
      )}

      {shouldShowBanks && (
        <BanksContainer>
          {isLoading ? (
            <Loading />
          ) : (
            filteredBanks?.map((bank) => (
              <BankItem
                bank={bank}
                key={bank.bankId}
                onClick={() => handleBankClick(bank)}
              />
            ))
          )}
        </BanksContainer>
      )}
      <IconContainer>
        {showFooter && <PHKOString />}
      </IconContainer>
    </ContentContainer>
  )
}

export default BankSelection
